import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/common/ui/Button";
import BannerContent from "./Pages/BannerContent";
import CalenderIntegrate from "./Pages/CalenderIntegrate";
import CommitteeDesc from "./Pages/CommitteeDesc";
import ContentSection from "./Pages/ContentSection";
import DownloadSection from "./Pages/DownloadSection";
import { useEffect, useState } from "react";
import { homePageActions } from "../../../_store/home.slice";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import homePageIntegrationSchema from "../../../validation/Admin/homePageIntegrationSchema";
import CustomLoader from "../../../components/common/ui/Loader";

function HomePageIntegration() {
  const dispatch = useDispatch();

  const { data } = useSelector((x) => x?.home?.homePageContentResponse);
  const { loading } = useSelector((x) => x?.home);

  const [errorMessage, setErrorMessage] = useState({});
  const [isPending, setIsPending] = useState(false);

  const [bannerImage, setBannerImage] = useState("");

  const [contentSecImage1, setContentSecImage1] = useState("");
  const [contentSecImage2, setContentSecImage2] = useState("");
  const [contentSecImage3, setContentSecImage3] = useState("");

  const [downloadSecImage1, setDownloadSecImage1] = useState("");
  const [downloadSecImage2, setDownloadSecImage2] = useState("");
  const [downloadSecImage3, setDownloadSecImage3] = useState("");

  const [downloadSecFile1, setDownloadSecFile1] = useState("");
  const [downloadSecFile2, setDownloadSecFile2] = useState("");
  const [downloadSecFile3, setDownloadSecFile3] = useState("");

  useEffect(() => {
    getHomePageContent();
    dispatch(homePageActions?.getTextEditorTemplate());
  }, []);

  const getHomePageContent = () => {
    dispatch(homePageActions?.homePageContent())
      .then((result) => {
        dispatch(homePageActions?.setHomePageData(result?.payload?.data));
      })
      .catch((err) => {
        showToastNotification("Failed to get data");
      });
  };

  const handleSubmit = (e) => {
    setErrorMessage({});
    e.preventDefault();
    setIsPending(true);
    const homePageData = { ...data };
    // dispatch(homePageActions.updateHomePageResponse(homePageData));

    const formData = new FormData();
    Object.keys(homePageData).forEach((key) => {
      if (homePageData[key] !== undefined && homePageData[key] !== null) {
        formData.append(key, homePageData[key]);
      }
    });
    if (bannerImage) {
      formData.append("bannerImageOne", bannerImage);
    }

    if (contentSecImage1) {
      formData.append("contentSectionOneImage", contentSecImage1);
    }
    if (contentSecImage2) {
      formData.append("contentSectionTwoImage", contentSecImage2);
    }
    if (contentSecImage3) {
      formData.append("contentSectionThreeImage", contentSecImage3);
    }
    //download sec images
    if (downloadSecImage1) {
      formData.append("downloadFirstCardImage", downloadSecImage1);
    }
    if (downloadSecImage2) {
      formData.append("downloadSecondCardImage", downloadSecImage2);
    }
    if (downloadSecImage3) {
      formData.append("downloadThirdCardImage", downloadSecImage3);
    }

    //download section URL
    if (downloadSecFile1) {
      formData.append("downloadFirstCardUrl", downloadSecFile1);
    }
    if (downloadSecFile2) {
      formData.append("downloadSecondCardUrl", downloadSecFile2);
    }
    if (downloadSecFile3) {
      formData.append("downloadThirdCardUrl", downloadSecFile3);
    }
    const { error } = homePageIntegrationSchema(homePageData);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    dispatch(homePageActions.updateHomePageIntegration(formData))
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch(() => {
        setIsPending(false);
        showToastNotification("Something went wrong", "error");
      });
  };

  const handleReset = (e) => {
    //
    // dispatch(homePageActions?.resetHomePageData());
    dispatch(homePageActions?.homePageContent());
  };

  if (loading) return <CustomLoader />;
  return (
    <form
      onSubmit={(e) => {
        handleSubmit(e);
      }}
      onReset={(e) => {
        handleReset(e);
      }}
    >
      <BannerContent
        onFileSelect={setBannerImage}
        errorMessage={errorMessage}
      />
      <CommitteeDesc errorMessage={errorMessage} />
      {/* <CalenderIntegrate errorMessage={errorMessage} /> */}
      <ContentSection
        Image1={setContentSecImage1}
        Image2={setContentSecImage2}
        Image3={setContentSecImage3}
        errorMessage={errorMessage}
      />
      <DownloadSection
        Image1={setDownloadSecImage1}
        Image2={setDownloadSecImage2}
        Image3={setDownloadSecImage3}
        File1={setDownloadSecFile1}
        File2={setDownloadSecFile2}
        File3={setDownloadSecFile3}
        errorMessage={errorMessage}
      />
      <div className="mt-3 d-flex justify-content-center align-items-center gap-3">
        <Button
          type="submit"
          label="Submit"
          status="primary"
          disabled={isPending}
        />
        <Button type="reset" label="Reset" status="reset" />
      </div>
    </form>
  );
}

export default HomePageIntegration;
